export const validateLinkedinUrl = (url: string) => {
  const regex = /http(s)?:\/\/([\w]+\.)?linkedin\.com\/in\/[A-z0-9_-]+\/?/
  return regex.test(url)
}
